import request from './request'

// 个人会员登录
export function memberLogin(data) {
  return request({
    url: '/api/member/login',
    method: 'post',
    data
  })
}

// 企业账号登录
export function companyLogin(data) {
  return request({
    url: '/api/company/login',
    method: 'post',
    data
  })
}

// 个人会员注册
export function memberRegister(data) {
  return request({
    url: '/api/member/register',
    method: 'post',
    data
  })
}

// 企业账号注册
export function companyRegister(data) {
  return request({
    url: '/api/company/register',
    method: 'post',
    data
  })
}

// 个人会员短信验证码
export function memberGetMessage(data) {
  return request({
    url: '/api/member/getMessage',
    method: 'post',
    data
  })
}

// 企业账号短信验证码
export function companyGetMessage(data) {
  return request({
    url: '/api/company/getMessage',
    method: 'post',
    data
  })
}

// 获取验证码图片
export function getCaptchaImage() {
  return request({
    url: '/api/captchaImage',
    method: 'get'
  })
}

// 个人会员忘记密码
export function memberForgotPassword(data) {
  return request({
    url: '/api/member/forgotPassword',
    method: 'post',
    data
  })
}

// 企业账号忘记密码
export function companyForgotPassword(data) {
  return request({
    url: '/api/company/forgotPassword',
    method: 'post',
    data
  })
}
